import {
  ALL_INFO_USER,
  FILES,
  FILES_DOWNLOAD,
  HISTORY,
  IS_PATIENT_AREA,
  LINKED_ACCOUNTS,
  MY_APPOINTMENTS,
  MY_PARAMS
} from "../actions/action-types";

export const patientAreaReducer = (
  state = {
    active: false,
    myAppointments: [],
    linkedAccounts: [],
    infosUser: {}
  },
  action
) => {
  if (action.type === IS_PATIENT_AREA) {
    return { active: action.active };
  }
  if (action.type === MY_APPOINTMENTS) {
    return {
      ...state,
      myAppointments: action.myAppointments
    };
  }
  if (action.type === LINKED_ACCOUNTS) {
    return {
      ...state,
      linkedAccounts: action.linkedAccounts
    };
  }
  if (action.type === HISTORY) {
    return {
      ...state,
      history: action.history
    };
  }
  if (action.type === FILES_DOWNLOAD) {
    return {
      ...state,
      filesDownload: action.files
    };
  }
  if (action.type === FILES) {
    return {
      ...state,
      files: action.files
    };
  }
  if (action.type === ALL_INFO_USER) {
    return {
      ...state,
      infosUser: action.infosUser
    };
  }
  if (action.type === MY_PARAMS) {
    return {
      ...state,
      params: { ...state.params, ...action.params }
    };
  }
  return state;
};
